// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"7d39a780","304":"653042e4","780":"a7eb9757","816":"3ec42532","977":"9e2fb662"}[chunkId] + ".chunk.js";
};